import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { runRtkQuery } from '../helperFn';

export const breadcrumbApi = createApi({
  reducerPath: 'breadcrumbApi',
  baseQuery: baseQuery,
  tagTypes: ['breadcrumb'],
  endpoints: (builder) => ({
    getBreadcrumb: builder.query({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'getBreadcrumb');
      },
      providesTags: ['breadcrumb'],
    }),
  }),
});

export const { useGetBreadcrumbQuery, useLazyGetBreadcrumbQuery } = breadcrumbApi;
